var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9971 34.5403C20.3638 32.6329 20.6761 30.6251 21.1175 28.6174C21.3347 27.5666 21.0699 27.1182 19.8953 27.1985C18.7207 27.2788 17.4102 27.2387 16.1609 27.1985C14.9116 27.1584 14.6875 26.5293 15.4072 25.6325C18.9515 21.2555 22.5365 16.9321 26.108 12.6221C26.5086 12.1335 26.9703 11.7855 27.6289 12.1536C28.2875 12.5217 28.1517 12.9768 28.0431 13.5256C27.6492 15.5334 27.3233 17.5411 26.8888 19.5087C26.6647 20.526 26.9567 20.8874 28.0159 20.8473C29.0789 20.7937 30.1441 20.7937 31.2071 20.8473C31.8114 20.8473 32.6058 20.5327 32.9181 21.3559C33.2305 22.1791 32.5718 22.5271 32.2391 23.0157C30.8812 24.6888 29.5051 26.3597 28.111 28.0284C26.0695 30.4645 24.0439 32.8917 22.0341 35.3099C21.6403 35.7851 21.1989 36.1666 20.5267 35.9256C19.8545 35.6847 19.9971 35.1158 19.9971 34.5403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.bc6919d0bb5c3c295bc10183174b0b3b.svg";
export { ForwardRef as ReactComponent };